// extracted by mini-css-extract-plugin
module.exports = {"PostsContainer":"Posts_PostsContainer__1--oS","NoPosts":"Posts_NoPosts__3b0tN","SpinnerContainer":"Posts_SpinnerContainer__1E5BW"};